var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionsEditNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59186 13.277H13.125M6.88811 4.25075L10.2956 6.86762M7.98749 2.872C8.22353 2.59305 8.55908 2.4172 8.92278 2.38184C9.28648 2.34647 9.64962 2.45438 9.93499 2.68262L11.0181 3.5245C11.1719 3.61571 11.3059 3.73681 11.4122 3.88066C11.5184 4.0245 11.5948 4.18818 11.6367 4.36202C11.6787 4.53587 11.6854 4.71635 11.6564 4.89282C11.6274 5.0693 11.5634 5.23818 11.4681 5.3895C11.4469 5.42325 5.50749 12.8526 5.50749 12.8526C5.40883 12.9751 5.2842 13.0741 5.1426 13.1425C5.00101 13.2109 4.84599 13.247 4.68874 13.2482L2.41499 13.277L1.90249 11.1082C1.83061 10.8026 1.90249 10.4826 2.09999 10.2357L7.98749 2.872Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsEditNew);
export default __webpack_public_path__ + "static/media/actions-edit-new.3c91da1ad5d99c1023fb5a4d6df1502f.svg";
export { ForwardRef as ReactComponent };